module.exports = __webpack_public_path__ + "img/arrow_back.4defd52d.svg";